import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';
import { browserHistory, Link } from 'react-router';

import Page from './containers/Page';
import ErrorPage from './components/ErrorPage';
import SignInWithSlackButton from './components/SignInWithSlackButton';
import SlashCommand from './components/SlashCommand';
import Loading from './components/Loading';
import ContactSupport from './components/ContactSupport';

const { isLoaded, pathToJS } = helpers;

@fb()
@connect(
  ({ firebase }) => ({
    authError: pathToJS(firebase, 'authError'),
    auth: pathToJS(firebase, 'auth')
  })
)
export default class MagicLink extends Component {
  static propTypes = {
    auth: PropTypes.object,
    authError: PropTypes.shape({
      message: PropTypes.string.isRequired
    }),
    firebase: PropTypes.object,
    location: PropTypes.shape({
      query: PropTypes.shape({
        token: PropTypes.string,
      }),
    }),
  }

  componentDidMount() {
    const { location: { query: { token } } } = this.props;
    if (!token) { return; }
    this.props.firebase.login({ token }).then(() => {
      browserHistory.replace('/dashboard');
    });
  }

  render() {
    const {
      auth,
      authError,
      location: { query: { token } },
    } = this.props;

    if (!token || authError) {
      if (Raven) {
        const error = !token ? 'No token' : authError;
        Raven.captureMessage('Magic link error', {
          extra: { error }
        });
      }

      // TODO detect actual magic link error if possible

      return (
        <ErrorPage
          subtitle="Please try signing in again:"
          title="Oops! Your magic link isn’t working"
        >
          <div className="mt4">
            <SignInWithSlackButton />
            <div className="mt4">
              or get a new magic link with the
              {' '}<SlashCommand suffix=" dashboard" />{' '}
              command
            </div>
            <ContactSupport className="mt3" />
          </div>
        </ErrorPage>
      );
    }

    return (
      <Page pageTitle="Magic Link">
        <div className="tc">
          {!isLoaded(auth) || !auth ?
            <Loading />
            :
            <div>
              <Link to="/dashboard">
                Click here
              </Link> to view your team.
            </div>
          }
        </div>
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/MagicLink.jsx
 **/